import React from "react";

interface CheckIconProps {
  className?: string;
}

export const CheckIcon = ({ className }: CheckIconProps) => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.9688 0.875C14.1354 0.6875 14.3021 0.6875 14.4688 0.875L14.8438 1.21875C15.0104 1.40625 15.0104 1.58333 14.8438 1.75L5.46875 11.125C5.28125 11.3125 5.10417 11.3125 4.9375 11.125L1.21875 7.40625C1.05208 7.23958 1.05208 7.0625 1.21875 6.875L1.59375 6.53125C1.65625 6.44792 1.73958 6.40625 1.84375 6.40625C1.94792 6.40625 2.03125 6.44792 2.09375 6.53125L5.1875 9.625L13.9688 0.875Z"
      fill="#666666"
    />
  </svg>
);

CheckIcon.defaultProps = {
  className: "",
};

CheckIcon.displayName = "CheckIcon";
